import { render, staticRenderFns } from "./DialogVideoPlayer.vue?vue&type=template&id=276b56f2&scoped=true&"
import script from "./DialogVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./DialogVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./DialogVideoPlayer.vue?vue&type=style&index=0&id=276b56f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276b56f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VDialog,VIcon})
